import styles from './LetterSpacingInput.module.css'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

function LetterSpacingInput({ name, value, onChange }) {
  return (
    <div className={styles.container}>
      <CustomNumber
        name={name}
        value={value}
        onChange={onChange}
        min={-1}
        step={0.1}
      />
    </div>
  )
}

export default LetterSpacingInput
